import styled from "styled-components";
import { useState, useEffect } from "react";
import request from "../../../api/request";
import { NotificationManager, NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import MessageLeftPane from "./MessageLeftPanel";
import MessageRightPane from "./MessageRightPanel";

const GrayBackground = styled.div`
    font-family: ${(props) => props.theme.fonts.SegoeUI};
    background-color: ${(props) => props.theme.color.lightgray};
    padding: 45px;
    height: calc(100vh - 210px);
    overflow: auto;


`;

const StyledMessages = styled.div`
    padding-top: 20px;
    display: flex;
`;

const PageTitle = styled.span`
    font-size: 20px;
    font-weight: 600;
    color: ${(props) => props.theme.color.dark};
`;

function Messages(props) {

    const [loadedPage, setLoadedPage] = useState(false);
    const [messages, setMessages] = useState([]);
    const [selectedMessage, setSelectedMessage] = useState(null);
    const [selectedMessageId, setSelectedMessageId] = useState(null);
    const [gridColumns, setGridColumns] = useState([
        {id: 'Date created', type: 'String', width: 130, textAlign: 'left'},
        {id: 'Message', type: 'String', width: 310, textAlign: 'left'},
        {id: 'User', type: 'String', width: 70, textAlign: 'center'},
        {id: 'ID', type: 'String', width: 50, textAlign: 'center'}
    ]);
    const [gridData, setGridData] = useState({groups: [''], items: [[]]});
    const [isAddMode, setIsAddMode] = useState(false);

    const onSelectGridItem = (item) => {
        setSelectedMessageId(item.Id);
        setSelectedMessage(messages[item.Id]);
    }

    const dateToStr = (date) => {
        function pad(s) { return (s < 10) ? '0' + s : s; };
        let ret = [pad(date.getDate()), pad(date.getMonth()+1), date.getFullYear()].join('/') + " " + [pad(date.getHours()), pad(date.getMinutes()), pad(date.getSeconds())].join(':');
        return ret;
    }

    const strToDate = (str) => {
        var date_components = str.split("/");
        var day = date_components[0];
        var month = date_components[1];
        var year = date_components[2];
        return new Date(year, month - 1, day);
    }

    const fetchMessages = async (messageIdToSelect) => {
        try {
            let messages = [];
            let gridDataMessages = [];

            let resp = (await request('database', 'fetchMessages'));
            if (resp.ok) {
                resp.data.map((message, index) => {
                    messages.push(message);
                    gridDataMessages.push({Id: index, 'Date created': dateToStr(new Date(message.MessageDate)), User: message.CreatedByUser, ID: message.Ident.toString(), ...message});

                    if (messageIdToSelect && message.MessageId === messageIdToSelect) {
                        setSelectedMessageId(index);
                        setSelectedMessage(message);
                    }
                });
                setMessages(messages);
                if (!messageIdToSelect) {
                    if (selectedMessageId)
                        setSelectedMessage(messages[selectedMessageId]);
                    else {
                        setSelectedMessage(messages[0]);
                        setSelectedMessageId(0);
                    }
                }
                setGridData({groups: [''], items: [gridDataMessages]});
            } else {
                console.log('Failed fetchMessages');
                NotificationManager.error(resp.data);
            }
        } catch (e) {
            console.log('Failed to fetch messages: ', e);
        }
    }

    useEffect(() => {
        if (!loadedPage) {
            fetchMessages();
            setLoadedPage(true);
        }
    }, [selectedMessage, isAddMode]);

    return (
        <GrayBackground>
            <div style={{display:'block', margin:'auto', width:1000}}>
                <PageTitle>Messages</PageTitle>
                <StyledMessages>
                    <MessageLeftPane gridColumns={gridColumns} gridData={gridData} messageIdToSelect={selectedMessageId} selectedMessage={selectedMessage} onSelectGridItem={(item) => onSelectGridItem(item)} isAddMode={isAddMode} setIsAddMode={(mode) => {setIsAddMode(mode)}} refreshMessagesCallback={fetchMessages} gridStyle={{width:560, height:400}}></MessageLeftPane>
                    <MessageRightPane messages={messages} selectedMessage={selectedMessage} isAddMode={isAddMode} setIsAddMode={(mode) => {setIsAddMode(mode)}} refreshMessagesCallback={fetchMessages} {...props}></MessageRightPane>
                </StyledMessages>
            </div>
            <NotificationContainer/>
        </GrayBackground>
    )
}

export default Messages;